module.exports = __webpack_public_path__ + "static/img/lightspeed-logo-o-series.0e2f84d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lightspeed-logo-o-series.jpg
// module id = rlz4
// module chunks = 1